module.exports = "/_next/static/images/civilConstruction-53fb3eba9ef2534b1c2564139746d7e2.webp";